import { Component } from '@angular/core';

@Component({
  selector: 'app-form-sale',
  template: ``,
  styleUrls: []
})
export class FormSaleComponent {

}
